import store from '../../store/store';
import { assertIsString } from '../asserts';
/**
 * Toggle the selection of a product to be comparised with other products. If product was previously
 * selected, it will be unselected, and viceversa.
 * @param productId The identifier of the product
 *
 * @example
 * ```ts
 * await brilliant.toggleProductSelection('563274356743');
 * ```
 *
 */
export function toggleProductSelection(productId: string): Promise<void> {
    assertIsString(productId);
    return store.dispatch.productComparisonState.toggleProductSelection(
        productId
    );
}
